import type { ComponentType } from 'react';

export const GAME_IDS = [
  'wordy',
  'mini-crossword',
  'clambers',
  'chromal',
  'ratiole',
  'shapeup',
  'mini-sudoku',
  'minesweeper',
  'queens',
  'nonogram',
  'paire',
] as const;

export type GameId = (typeof GAME_IDS)[number];
export type RunMode = 'practice' | 'competitive';
export type OutcomeKind = 'solved' | 'failed' | 'skipped';

export type PuzzleEnvelope<P = unknown> = {
  gameId: GameId;
  seed: number;
  generatorVersion: number;
  dataVersion: number;
  payload: P;
};

export type GameOutcome = {
  kind: OutcomeKind;
  baseDeltaMs: number;
  message: string;
  metadata?: Record<string, unknown>;
};

export type GameComponentProps<P = unknown> = {
  puzzle: PuzzleEnvelope<P>;
  savedState: unknown;
  disabled: boolean;
  reducedMotion: boolean;
  onStateChange: (state: unknown) => void;
  onCharge: (key: string, amountMs: number, label: string) => void;
  onComplete: (outcome: GameOutcome) => void;
};

export type GameDefinition<P = unknown> = {
  id: GameId;
  displayName: string;
  shortRules: string;
  generatorVersion: number;
  dataVersion: number;
  skip: {
    practiceDelayMs: number;
    competitiveDelayMs: number | null;
    penaltyMs: number;
  };
  Component: ComponentType<GameComponentProps<P>>;
};
